<template>
    <div style="background-color:antiquewhite">
    <v-img style="height:100vh" :src="require('@/assets/books.jpg')" v-if="!isMobile">
        <div style="display:flex; justify-content:center; margin-top:64px">
            <v-card style="min-height:1000px; width:80vw; background-color:antiquewhite; margin-bottom:16px; padding-bottom:16px;">            
                <h1 style="text-align:center; font-size:38px;">Support the Akashic Paths Project</h1>
                <v-divider/>
                <v-card-text style="font-weight:500">
                    Akashic Paths is a passion project from just a single person, so any support you can give means a lot, and really helps me out too. Creating content for pathfinder is a passion of mine, and I'd love to be able to continue to do so, and see the project fufilled to completion for as many people to enjoy as I can manage.
                    If you enjoyed playing the Akashic Paths please consider supporting it or buying the full version. Right now all the costs of running the servers and development are coming out of my pocket, which unfortunately isn't something I can do forever.
                    <br/><br/><h3>Patreon:</h3>
                    If you want to buy the full game you can do that by becoming a supporter on patreon.
                    <br/>By supporting the game on patreon you gain access to the full version of the game including having no limit on in game rolls, as well as being able to download and upload saves to the game. Only the host of the server needs to have the full version of the game to get its benefits.
                    <br/><br/>Once you sign up on patreon an email will be sent to the email you have registered with patreon that has a key for registering your account, then you can register your account when you host a game. This access only remains while you're a supporter. 
                    <br/><a style="font-size:18px" href="https://www.patreon.com/AkashicPaths">Support on Patreon</a>
                    <br/><br/><h3>Ko-fi:</h3>
                    If you just want to send a few dollars my way to keep the servers on and coffee in my cup for those late night coding binges you can do so at ko-fi:  
                    <br/><a style="font-size:18px" href="https://www.ko-fi.com/akashicpaths">Support on Kofi</a>
                    <br/><br/><h3>Share Us Around:</h3>
                    <p>If you still want to support us for free you can help out a ton by sharing the project around with people you think might be interested!
                        </p>
                    Thank you for your support! 
                    <br/><br/><h2>Contact:</h2>
                    <a style="font-size:18px" href="https://discord.gg/ZTrp4aS7C3">Join the Official Discord</a> I am very active here, happy to answer any questions or deal with any technical issues.
                    <br/><br/>You can also email me at <b style="font-weight:800">akashicpaths@gmail.com</b> for any questions/business concerns
                </v-card-text>
            </v-card>
        </div>
    </v-img>
    <div v-else style="background-color:antiquewhite">
        <v-card style="min-height:1000px; background-color:antiquewhite; margin-bottom:16px; padding-bottom:16px;" flat>            
                <h1 style="text-align:center; font-size:38px;">Support the Akashic Paths Project</h1>
                <v-divider/>
                <v-card-text style="font-weight:500; text-align:center">
                    Akashic Paths is a passion project from just a single person, so any support you can give means a lot, and really helps me out too. Creating content for pathfinder is a passion of mine, and I'd love to be able to continue to do so, and see the project fufilled to completion for as many people to enjoy as I can manage.
                    If you enjoyed playing the Akashic Paths please consider supporting it or buying the full version. Right now all the costs of running the servers and development are coming out of my pocket, which unfortunately isn't something I can do forever.
                    <br/><br/><h3>Patreon:</h3>
                    If you want to buy the full game you can do that by becoming a supporter on patreon.
                    <br/>By supporting the game on patreon you gain access to the full version of the game including having no limit on in game rolls, as well as being able to download and upload saves to the game. Only the host of the server needs to have the full version of the game to get its benefits.
                    <br/><br/>Once you sign up on patreon an email will be sent to the email you have registered with patreon that has a key for registering your account, then you can register your account when you host a game. This access only remains while you're a supporter. 
                    <br/><a style="font-size:18px" href="https://www.patreon.com/AkashicPaths">Support on Patreon</a>
                    <br/><br/><h3>Ko-fi:</h3>
                    If you just want to send a few dollars my way to keep the servers on and coffee in my cup for those late night coding binges you can do so at ko-fi:  
                    <br/><a style="font-size:18px" href="https://www.ko-fi.com/akashicpaths">Support on Kofi</a>
                    <br/><br/><h3>Share Us Around:</h3>
                    <p>If you still want to support us for free you can help out a ton by sharing the project around with people you think might be interested!
                        </p>
                    Thank you for your support! 
                    <br/><br/><h2>Contact:</h2>
                    <a style="font-size:18px" href="https://discord.gg/ZTrp4aS7C3">Join the Official Discord</a><br/> I am very active here, happy to answer any questions or deal with any technical issues.
                    <br/><br/>You can also email me at <b style="font-weight:800">akashicpaths@gmail.com</b> for any questions/business concerns
                </v-card-text>
            </v-card>
    </div>
    </div>
</template>

<script>
import {
VCard,
VCardText,
VImg,
VDivider,
} from "vuetify/lib";
export default {
  components: {    
      VCard,
      VCardText,
      VImg,
      VDivider,
  },
  computed:{
    isMobile(){
       if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
            return true
        }else{
            return false
        }
    }
  }
}
</script>
